import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface UpdateVideoInterface {
  vid: string;
  title: string;
  coverImageUrl: string;
}

export const useUpdateVideo = () => {
  const mutate = useMutation(({ vid, title, coverImageUrl }: UpdateVideoInterface) => {
    return postAPI('/media-api/update_video_details', {
      vid,
      title,
      cover_image_url: coverImageUrl,
    });
  });

  return mutate;
};

export default useUpdateVideo;
